import { Tenant } from '../contexts/TenantContext';

export interface TenantService {
  getCurrentTenant(): Tenant | null;
  setCurrentTenant(tenant: Tenant): void;
  getCurrentTenantCode(): string;
  clearCurrentTenant(): void;
}

class TenantServiceImpl implements TenantService {
  private readonly STORAGE_KEY = 'currentTenant';

  getCurrentTenant(): Tenant | null {
    try {
      const tenantJson = localStorage.getItem(this.STORAGE_KEY);
      if (!tenantJson) {
        return null;
      }

      return JSON.parse(tenantJson);
    } catch (error) {
      console.error('Error parsing current tenant from localStorage:', error);
      return null;
    }
  }

  setCurrentTenant(tenant: Tenant): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(tenant));
    } catch (error) {
      console.error('Error saving current tenant to localStorage:', error);
    }
  }

  getCurrentTenantCode(): string {
    const tenant = this.getCurrentTenant();
    if (!tenant?.code) {
      throw new Error('No tenant selected. Please select a tenant to continue.');
    }
    
    // Allow all tenant codes - remove restrictive validation
    // This was causing issues with legitimate tenants
    return tenant.code;
  }

  clearCurrentTenant(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing current tenant from localStorage:', error);
    }
  }
}

export const tenantService = new TenantServiceImpl();
